import axios from 'axios'
import { AUTH_SERVICE_URL, CLIENT_ID } from '../consts'

const sendOtp = async (phoneNumber: string): Promise<void> => {

  await axios.post(`${AUTH_SERVICE_URL}/send-otp `, { phoneNumber, clientId: CLIENT_ID })
}

export default sendOtp